import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-riLine-file-list-3-line",
  "use": "icon-riLine-file-list-3-line-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-riLine-file-list-3-line\">\r\n    <path d=\"M25.333 29.333h-18.667c-2.209 0-4-1.791-4-4v0-21.333c0-0.736 0.597-1.333 1.333-1.333v0h18.667c0.736 0 1.333 0.597 1.333 1.333v0 16h5.333v5.333c0 2.209-1.791 4-4 4v0zM24 22.667v2.667c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v0-2.667h-2.667zM21.333 26.667v-21.333h-16v20c0 0.736 0.597 1.333 1.333 1.333v0h14.667zM8 9.333h10.667v2.667h-10.667v-2.667zM8 14.667h10.667v2.667h-10.667v-2.667zM8 20h6.667v2.667h-6.667v-2.667z\" />\r\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/riLine-file-list-3-line.svg
// module id = EyUx
// module chunks = 24